export default "__VITE_ASSET__1af28cf1__"